<template>
    <div class="checkbox-group" v-if="badge.id > 0">
        <div class="checkbox-left">
            <switches @input="setValue" :enabled="saleOnlyHere" value="sale_only_here"></switches>
            <span class="desc">{{ __( 'Exclusive to Platform', 'dokan' ) }}</span>
        </div>
    </div>
</template>

<script>
const Switches = dokan_get_lib('Switches');
import defaultBadgeData from '../../../BadgeSingle.json';

export default {
    name: 'SaleOnlyHere',
    components: {
        Switches,
        defaultBadgeData,
    },
    props: {
        vendorInfo: {
            type: Object
        }
    },
    data () {
        return {
            badge: defaultBadgeData,
            saleOnlyHere: false,
        }
    },
    methods: {
        setValue( status, key ) {
            if ( 'sale_only_here' === key ) {
                this.saleOnlyHere = status;
                this.vendorInfo.sale_only_here = status;
            }
        },
        fetchBadgeData () {
            let self = this;
            self.isLoading = true;
            const args = {
                event_type: 'exclusive_to_platform',
                badge_status: 'published',
                page: 1,
                per_page: 1,
            };
            dokan.api.get('/seller-badge/', args)
            .done(async ( response, status, xhr ) => {
                self.badge = defaultBadgeData;
                if ( response.length > 0 ) {
                    self.badge = response[0];
                }
            }).always( () => {
                self.isLoading = false;
            } ).fail( ( jqXHR ) => {
                self.badges = defaultBadgeData;
            } );
        },
    },
    created () {
        this.$watch(
            () => this.$route.params,
            () => {
                this.fetchBadgeData()
            },
            // fetch the data when the view is created and the data is
            // already being observed
            { immediate: true }
        )

        if ( true === this.vendorInfo.sale_only_here ) {
            this.saleOnlyHere = true;
        }
    },
}
</script>
